enum ClockType {
  DEVICE_AUTO = 10,
  DEVICE_MANUAL = 20,
  BUSY_CLOCK = 30,
  USER_CUSTOM = 40,
}

export default ClockType;
